<template>
    <div>
        <b-card class="mt-2">
            <b-row>
                <div class="my-2 mx-2">
                    <h3>Ver Persona</h3>
                </div>
            </b-row>
            <b-row>
                <b-col md="6">
                    <label><b>Nombres: *</b></label>
                    <b-form-input v-model="nombres" :class="{ 'input-error': errors.nombres }" disabled></b-form-input>
                </b-col>
                <b-col md="6">
                    <label><b>Apellidos: *</b></label>
                    <b-form-input v-model="apellidos" :class="{ 'input-error': errors.apellidos }"
                        disabled></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col md="6">
                    <label><b>Tipo de Identificación: *</b></label>
                    <v-select v-model="tipoIdent" :options="opsTipoIdent" label="text"
                        :class="{ 'input-error': errors.tipoIdent }" disabled />
                </b-col>
                <b-col md="6">
                    <label><b>Identificación: *</b></label>
                    <b-form-input v-model="identificacion" :class="{ 'input-error': errors.identificacion }"
                        :maxlength="tipoIdent.value === '1' ? 10 : null" @input="validarIdentificacion"
                        disabled></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col md="4">
                    <label><b>Teléfono: *</b></label>
                    <b-form-tags v-model="celular" :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
                        :tag-validator="tagValidator" separator=" " input-type="number" placeholder="099999999"
                        :class="{ 'input-error': errors.celular }" disabled />
                </b-col>
                <b-col md="4">
                    <label><b>Correo: *</b></label>
                    <b-form-input v-model="email" :class="{ 'input-error': errors.email }" disabled></b-form-input>
                </b-col>
                <b-col md="4">
                    <label><b>Fecha Nacimiento:</b></label>
                    <b-form-datepicker v-model="fechaNacimiento" disabled></b-form-datepicker>
                </b-col>
            </b-row>
           
        </b-card>
    </div>
</template>

<script>

import { BootstrapVue } from 'bootstrap-vue';

import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';



export default {
    name: "VerPersona",


    components: {
        ...BootstrapVue.components,
        BCardCode,
        vSelect,
        axios,
        rutas,

    },
    props: {
        idPersona: {
            type: String,
            default: null,
        },
    },




    data() {

        return {
            opsTipoIdent: [
                { value: '0', text: 'RUC' },
                { value: '1', text: 'Cedula' },
                { value: '2', text: 'Passporte' }
            ],
            identificaciones: null,
            nombres: null,
            apellidos: null,
            tipoIdent: { value: '1', text: 'Cedula' },
            identificacion: null,
            celular: [],
            email: null,
            fechaNacimiento: null,

            errors: {
                nombres: false,
                apellidos: false,
                tipoIdent: false,
                identificacion: false,
                celular: false,
                email: false,
            }
        }
    },

    created() {

        this.fetchPersonaById()
        
    },

    methods: {
        async fetchPersonaById() {
            const query = `
        query MyQuery($idPersona: ID) {
            getPersonaById(idPersona: $idPersona) {
                
                
                    correo
                    telefono
                    identificacion
                    primerApellido
                    primerNombre
                    primerApellido
                    fechaNacimiento
                    id
                
            }
        }`;

            try {
                const response = await axios.post(rutas.axios + "api", {
                    query,
                    variables: {
                        idPersona: this.idPersona

                    }
                });



                
                let persona = response.data.data.getPersonaById;
                console.log(persona, "esta es")
                this.nombres = persona.primerNombre || ""
                this.apellidos = persona.primerApellido || ""
                this.identificacion = persona.identificacion || ""
                this.celular = persona.telefono || ""
                this.email = persona.correo || ""
                this.fechaNacimiento = persona.fechaNacimiento || ""



            } catch (error) {
                console.error("Error buscando personas:", error.response ? error.response.data : error.message);
            }
        },
      
    },

    



}


</script>

<style>
.input-error {
    border-color: red !important;
}
</style>